import axios from "axios";
import domain from "./domain";

export const fetchHRivers = async () => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/fetch-himalayan-river-names`
    );
    if (result) {
      return result;
    }
  } catch (error) {}
};

export const fetchHRiverBoundary = async (river) => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/get-himalayan-basin/${river}`
    );
    if (result) {
      return result;
    }
  } catch (error) {}
};

export const fetchHBasins = async (river) => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/get-river-basin/${river}`
    );
    if (result) {
      console.log(result);
      return result;
    }
  } catch (error) {}
};

export const fetchRiverStats = async (date) => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/get-river-stats/${date}`
    );
    if (result) {
      console.log(result);
      return result;
    }
  } catch (error) {}
};

export const fetchRiverStatsDefault = async () => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/get-river-stats-default`
    );
    if (result) {
      console.log(result);
      return result;
    }
  } catch (error) {}
};

export const fetchRiverBasinStats = async (river, date) => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/get-river-basin-stats/${river}/${date}`
    );
    if (result) {
      console.log(result);
      return result;
    }
  } catch (error) {}
};

export const fetchRiverStatsByDates = async (river, start_date, end_date) => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/get-river-stats-dates/${river}/${start_date}/${end_date}`
    );
    if (result) {
      console.log(result);
      return result;
    }
  } catch (error) {}
};

export const fetchRiverStatsByDatesDefault = async (start_date, end_date) => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/get-river-stats-default-dates/${start_date}/${end_date}`
    );
    if (result) {
      console.log(result);
      return result;
    }
  } catch (error) {}
};

export const fetchRiverBasinStatsByDates = async (
  river,
  basin,
  start_date,
  end_date
) => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/get-river-basin-stats-dates/${river}/${basin}/${start_date}/${end_date}`
    );
    if (result) {
      console.log(result);
      return result;
    }
  } catch (error) {}
};

export const fetchHRiverBasinBoundary = async (river, basin) => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/get-himalayan-river-basin-boundary/${river}/${basin}`
    );
    if (result) {
      return result;
    }
  } catch (error) {}
};

//you added today- scf start and end date
export const fetchSnowFractionDatesStartEnd = async (long,lat,start_date,end_date) => {
  try {
    const result = await axios.get(
      `${domain.DBServer}/fetch-snow-cover-fraction-SDED/${long}/${lat}/${start_date}/${end_date}`
    );
    if (result) {
      return result;
    }
  } catch (error) {}
};
// FORMAT IS MM-DD-YYYY
//fetch-snow-cover-fraction-SDED/:11-01-2020/:08-15-2023 WHERE 11 IS MONTH, 01 IS DAY AND 2020 IS YEAR